import { render, staticRenderFns } from "./pricing-card.vue?vue&type=template&id=2b08b33c&scoped=true"
import script from "./pricing-card.vue?vue&type=script&lang=js"
export * from "./pricing-card.vue?vue&type=script&lang=js"
import style0 from "./pricing-card.vue?vue&type=style&index=0&id=2b08b33c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b08b33c",
  null
  
)

export default component.exports